import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';

import I18n from 'PMT/i18n/I18n';

// -- entities
import UpsellingCategory from 'PMT/entities/menu/UpsellingCategory';
import RestaurantMenu from 'PMT/entities/menu/RestaurantMenu';

// -- constants
import Events from 'constants/Events';

// -- stores
import RestaurantMenuStore from 'stores/RestaurantMenuStore';

// -- views
import { Modal } from 'react-bootstrap';
import AddItemToUpsellingCategoryView from './AddItemToUpsellingCategoryView';

export default class AddItemToUpsellingCategoryModal extends Component {

  static propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,

    upsellingCategory: PropTypes.instanceOf(UpsellingCategory),

    restaurantMenu: PropTypes.instanceOf(RestaurantMenu)
  };

  componentDidMount() {
    RestaurantMenuStore.addListener(Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onChange);
  }

  shouldComponentUpdate(nextProps: Object) {
    return nextProps.show !== this.props.show
        // an update have been made
      || !nextProps.restaurantMenu.equals(this.props.restaurantMenu)
      || this.props.upsellingCategory.equals(nextProps.upsellingCategory);
  }

  componentWillUnmount() {
    RestaurantMenuStore.removeListener(Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onChange);
  }

  onChange = () => {
    this.props.onHide();
  };

  onHide = () => {
    this.props.onHide();
  };

  onClose = () => {
    this.props.onHide();
  };

  render() {
    return (
      <Modal
        bsSize="large"
        show={this.props.show}
        onHide={this.onHide}
      >
        <Modal.Header>

          <button
            type="button"
            className="close close-white"
            onClick={this.onClose}
          >
            <span aria-hidden="true">×</span>
          </button>

          <Modal.Title>
            {I18n.tr('menu.upselling_category.add_item.modal_title')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddItemToUpsellingCategoryView
            upsellingCategory={this.props.upsellingCategory}
            restaurantMenu={this.props.restaurantMenu}
          />
        </Modal.Body>
      </Modal>
    );
  }
}
